const automation = {
  onboardingModal: {
    title: 'Primer acceso',
    welcomeStep: {
      title: '¡Bienvenido a Automatización Clicksign!',
      content: [
        'Estás comenzando una nueva jornada que transformará tus envíos y firmas.',
        'Mira en este y en los próximos videos lo que Michael Bernstein, Founder & CRO de Clicksign, tiene que decir sobre Automatización y las posibilidades para tu negocio.',
        'Aprovecha esta oportunidad para optimizar tus procesos y ahorrar tiempo, gestionando documentos de forma simplificada y estratégica.',
      ],
      action: 'Comenzar',
    },
    templateStep: {
      title: 'Modelos: todo lo que necesitas saber.',
      content: [
        'La modelo de Clicksign es una forma práctica e inteligente de crear documentos personalizados sin necesidad de editar uno por uno. Permite generar los documentos automáticamente para la firma, haciendo la gestión mucho más simple.',
        'Mira el video y descubre más.',
      ],
    },
    formFlowStep: {
      title: 'Flujos con formulario: genera contratos con agilidad.',
      content: [
        'Aprende cómo utilizar el flujo con formulario y simplifica tu rutina de negocios al generar documentos personalizados y rellenados automáticamente con los datos de tus usuarios.',
        'Mira el video y descubre más.',
      ],
    },
    spreadsheetFlowStep: {
      title: 'Flujos con planilla: escalabilidad para tus documentos.',
      content: [
        'Este flujo está hecho para quien ya tiene la información de los usuarios organizada en una planilla, que funcionan como base de datos para la generación automática de los documentos. Es la opción ideal para enviar múltiples documentos para firmar con agilidad y seguridad.',
        'Mira el video y descubre más.',
      ],
    },
    startAutomationStep: {
      title: '¡Felicidades! Has concluido tu recorrido por la guía.',
      description:
        'Selecciona una de las funcionalidades a continuación y comienza tu jornada en la práctica:',
      templateOption: 'Crear modelo',
      formFlowOption: 'Crear flujo con formulario',
      spreadsheetFlowOption: 'Crear flujo con planilla',
      action: 'Comenzar',
      helpButtonReminder:
        'Si aún tienes dudas o necesitas consultar la guía nuevamente, simplemente haz clic en el botón de Ayuda.',
      conclusion: 'Cuente con Clicksign en esta jornada.',
    },
    alert: 'Consulta la guía de Primeros pasos cuando quieras, haciendo clic en el botón de Ayuda.',
  },
};

export default automation;
